import { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <nav className="nav">
          <div className="nav-brand" onClick={() => scrollToSection('hero')}>
            <img src="/assets/images/TMC-logo.png" alt="Tahoe Mountain Cars Logo" className="nav-logo" />
            <h1 className="logo">Tahoe Mountain Cars</h1>
          </div>

          {/* Hamburger Button */}
          <button 
            className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Navigation Menu */}
          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <li>
              <a onClick={() => scrollToSection('why-choose')}>Why Choose Us</a>
            </li>
            <li>
              <a onClick={() => scrollToSection('inventory')}>Inventory</a>
            </li>
            <li>
              <a onClick={() => scrollToSection('locations')}>Locations</a>
            </li>
            <li>
              <a href="https://blog.tahoemountaincars.com">Blog</a>
            </li>
            <li>
              <a onClick={() => scrollToSection('signup')} className="nav-cta">
                Sign Up
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
